<template>
  <svg
    width="16"
    height="14"
    viewBox="0 0 16 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.3672 7.03556C10.3672 8.34506 9.30525 9.40631 7.99575 9.40631C6.68625 9.40631 5.625 8.34506 5.625 7.03556C5.625 5.72531 6.68625 4.66406 7.99575 4.66406C9.30525 4.66406 10.3672 5.72531 10.3672 7.03556Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.9985 12.5155C10.8545 12.5155 13.4668 10.462 14.9375 7.039C13.4668 3.616 10.8545 1.5625 7.9985 1.5625H8.0015C5.1455 1.5625 2.53325 3.616 1.0625 7.039C2.53325 10.462 5.1455 12.5155 8.0015 12.5155H7.9985Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
